// utils/pdfUtils.js
import { FUENTES, POSICIONES, COLORES, LINEAS } from "./pdfEstilos";
import jsPDF from "jspdf";

export const cargarLogo = async (logoPath) => {
  const response = await fetch(logoPath);
  const blob = await response.blob();

  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};

const dibujarEncabezado = (doc, logoBase64) => {
  // Logo
  doc.addImage(logoBase64, "PNG", 20, 10, 40, 15);

  doc.setFont(FUENTES.TITULO.font, FUENTES.TITULO.style);
  doc.setFontSize(FUENTES.TITULO.size);
  doc.text("Parte de avería", POSICIONES.MARGEN_X, POSICIONES.ENCABEZADO_Y);

  // Linea
  doc.setDrawColor(COLORES.LINEA);
  doc.setLineWidth(LINEAS.GROSOR);
  doc.line(...LINEAS.POSICION_ENCABEZADO);
};

const dibujarPieDePagina = (
  doc,
  { emailCliente, firmaBase64, tecnicosSeleccionados, fecha }
) => {
  // Fecha
  doc.setFont(FUENTES.TEXTO_BOLD.font, FUENTES.TEXTO_BOLD.style);
  doc.setFontSize(FUENTES.TEXTO.size);
  doc.text("Fecha:", POSICIONES.MARGEN_X, POSICIONES.PIE_Y);
  doc.setFont(FUENTES.TEXTO.font, FUENTES.TEXTO.style);
  doc.text(`${fecha}`, POSICIONES.MARGEN_X + 15, POSICIONES.PIE_Y);

  // Email
  doc.setFont("Century Gothic", "bold");
  doc.text("Email:", 20, 230);
  doc.setFont("Century Gothic", "normal");
  doc.text(emailCliente, 20, 235);

  // Firma
  if (firmaBase64) {
    doc.setFont("Century Gothic", "bold");
    doc.text("Firma del cliente:", 20, 250);
    doc.addImage(firmaBase64, "PNG", 20, 255, 60, 20);
  }

  // Técnicos
  doc.setFontSize(12).setFont("Century Gothic", "bold");
  doc.text("Técnicos asignados:", 120, 250);
  if (tecnicosSeleccionados.length > 0) {
    doc.setFont("Century Gothic", "normal");
    tecnicosSeleccionados.forEach((tecnico, index) => {
      const nombre = tecnico.username;
      doc.text(`- ${nombre}`, 120, 257 + index * 6);
    });
  }
};

const datos = (doc, pdfTicket) => {
  //Títulos
  doc.setFont(FUENTES.SUBTITULO.font, FUENTES.SUBTITULO.style);
  doc.setFontSize(FUENTES.SUBTITULO.size);
  doc.text(`Nombre:`, POSICIONES.MARGEN_X, POSICIONES.DATOS_Y);
  doc.text(`Dirección:`, POSICIONES.MARGEN_X, POSICIONES.DATOS_Y + 6);
  doc.text(`Avería:`, POSICIONES.MARGEN_X, POSICIONES.DATOS_Y + 12);
  //Datos
  doc.setFont(FUENTES.TEXTO.font, FUENTES.TEXTO.style);
  doc.setFontSize(FUENTES.TEXTO.size);
  doc.text(
    `${pdfTicket.nombre}`,
    POSICIONES.MARGEN_DATOS_X + 1,
    POSICIONES.DATOS_Y
  );
  doc.text(
    ` ${pdfTicket.direccion}`,
    POSICIONES.MARGEN_DATOS_X + 4,
    POSICIONES.DATOS_Y + 6
  );
  doc.text(
    `${pdfTicket.tipoaveria}`,
    POSICIONES.MARGEN_DATOS_X - 2,
    POSICIONES.DATOS_Y + 12
  );
  // Linea Datos
  doc.setDrawColor(COLORES.LINEA);
  doc.setLineWidth(LINEAS.GROSOR);
  doc.line(...LINEAS.POSICION_DATO);
};

const resolucionAveria = (
  doc,
  resolucion,
  logoBase64,
  pdfTicket,
  estado,
  pieData,
  datos
) => {
  const MAX_LINEAS = 22;
  doc.setFont(FUENTES.SUBTITULO.font, FUENTES.SUBTITULO.style);
  doc.setFontSize(FUENTES.SUBTITULO.size);
  doc.text("Resolución:", POSICIONES.MARGEN_X, POSICIONES.DATOS_Y + 20);
  doc.setFont(FUENTES.TEXTO.font, FUENTES.TEXTO.style);
  doc.setFontSize(FUENTES.TEXTO.size);
  const resolucionLineas = doc.splitTextToSize(
    resolucion,
    POSICIONES.ANCHO_TEXTO
  );
  doc.setFont(FUENTES.TEXTO_BOLD.font, FUENTES.TEXTO_BOLD.style);
  doc.setFontSize(FUENTES.TEXTO_BOLD.size);
  doc.text(
    "Estado avería:",
    POSICIONES.MARGEN_X + 110,
    POSICIONES.DATOS_Y + 20
  );
  doc.setFont(FUENTES.TEXTO.font, FUENTES.TEXTO.style);
  doc.setFontSize(FUENTES.TEXTO.size);
  doc.text(estado, POSICIONES.MARGEN_X + 140, POSICIONES.DATOS_Y + 20);
  if (resolucionLineas.length <= MAX_LINEAS) {
    doc.text(resolucionLineas, POSICIONES.MARGEN_X, POSICIONES.DATOS_Y + 26);
    dibujarPieDePagina(doc, pieData);
  } else {
    const primeraParte = resolucionLineas.slice(0, MAX_LINEAS);
    doc.text(primeraParte, POSICIONES.MARGEN_X, POSICIONES.DATOS_Y + 26);
    dibujarPieDePagina(doc, pieData);

    //Página 2
    doc.addPage();
    dibujarEncabezado(doc, logoBase64);
    datos(doc, pdfTicket);

    doc.setFont(FUENTES.SUBTITULO.font, FUENTES.SUBTITULO.style);
    doc.setFontSize(FUENTES.SUBTITULO.size);
    doc.text(
      "Resolución (continuación):",
      POSICIONES.MARGEN_X,
      POSICIONES.DATOS_Y + 20
    );
    dibujarPieDePagina(doc, pieData);
  }
  doc.setFont(FUENTES.TEXTO.font, FUENTES.TEXTO.style);
  doc.setFontSize(FUENTES.TEXTO.size);
  const segundaParte = resolucionLineas.slice(MAX_LINEAS + 10);
  doc.text(segundaParte, POSICIONES.MARGEN_X, POSICIONES.DATOS_Y + 25);
};

export const crearPDF = async ({
  pdfTicket,
  resolucion,
  firmaBase64,
  logoBase64,
  tecnicosSeleccionados,
  estado,
  emailCliente,
}) => {
  const doc = new jsPDF();

  const fecha = new Date().toLocaleDateString();

  // Encabezado de Página
  dibujarEncabezado(doc, logoBase64);

  // Datos Cliente
  datos(doc, pdfTicket);

  // Resolución Avería
  resolucionAveria(
    doc,
    resolucion,
    logoBase64,
    pdfTicket,
    estado,
    {
      emailCliente,
      firmaBase64,
      tecnicosSeleccionados,
      fecha,
    },
    datos
  );

  const totalPages = doc.internal.getNumberOfPages();
  for (let i = 1; i <= totalPages; i++) {
    doc.setPage(i);
    doc.setFontSize(8);
    doc.setFont("Century Gothic", "italic");
    doc.text(`Página ${i} de ${totalPages}`, 180, 290);
  }

  return doc;
};
